import { render, staticRenderFns } from "./NewsSectionConfigForm.vue?vue&type=template&id=773fa364&scoped=true&"
import script from "./NewsSectionConfigForm.vue?vue&type=script&lang=js&"
export * from "./NewsSectionConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773fa364",
  null
  
)

export default component.exports